/**
 * Convert two strings to numbers and ensure first is less than or equal to second
 */
function numberCompare(gte: string, lte: string) {
  return Number(gte) <= Number(lte);
}

type RangeKey = [string, string, (gte: string, lte: string) => boolean, string];
const rangeKeys: RangeKey[] = [
  ["collectionSizeGte", "collectionSizeLte", numberCompare, "Collection Size"],
];

function validateFilterForm(data: FormData) {
  const errors: { [fieldName: string]: string } = {};

  const fields = Object.fromEntries(data);

  rangeKeys.forEach(([gte, lte, compareFn, display]) => {
    const gteVal = fields[gte];
    const lteVal = fields[lte];

    // If neither value exists, skip validation
    if (gteVal || lteVal) {
      // Check that both values of range are defined
      if (
        (gteVal !== "" && lteVal === "") ||
        (gteVal === "" && lteVal !== "")
      ) {
        // Set the error on the non-existing field
        errors[
          gteVal === "" ? gte : lte
        ] = `${display}: Please define both sides of a range filter.`;
      }

      // Check gte values are lower than or equal to Lte
      if (!compareFn(gteVal as string, lteVal as string)) {
        errors[lte] = `${display}: Value is below the lower bound.`;
      }
    }
  });

  return Object.keys(errors).length ? errors : null;
}

export { validateFilterForm };
